
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { LoadAllSchoolId } from '../actions/Activites/School';
import { CreateComment, LoadAllCommentSubjectId } from '../actions/Comments/CommentAction';
import { Localvalue } from '../nametitle/localValue';
import { useParams } from 'react-router-dom';
import { getDataFromFile } from '../actions/SearchAction';

const VideoPage = () => {

  const params = useParams();
  var id = localStorage.getItem(Localvalue.idSchool);
  var urlvideo = localStorage.getItem(Localvalue.urlSchoolVideo);
  var title = localStorage.getItem(Localvalue.titleSchool);
  var description = localStorage.getItem(Localvalue.descriptionSchool);

  const [typecomment, settypecomment] = useState("video");
  const [content, setcontent] = useState(""); const [SchoolGet, setSchoolGet] = useState([]);
  const [commentList, setcommentList] = useState([]);
  const [commentListSearch, setcommentListSearch] = useState([]);

  useEffect(() => {

    if (params && params.id) {
      const myList = getDataFromFile(Localvalue.enseignementsData);
      const myObject = myList.find(item => item._id === params.id);
      setSchoolGet(myObject ? myObject : "");
      LoadAllSchoolId(id, setSchoolGet);
      LoadAllCommentSubjectId(id, setcommentList, setcommentListSearch);
    } else {
      LoadAllSchoolId(id, setSchoolGet);
      LoadAllCommentSubjectId(id, setcommentList, setcommentListSearch);
    }
  }, [])
  return (
    <div className="container-fluid w-full flex flex-col space-y-3 justify-center">
      <div className="container">
        <ReactPlayer url={`${SchoolGet && SchoolGet.video ? SchoolGet.video: ""}`} playing={true} controls width={"100%"} height={"500px"} />
        <div className="py-3 px-1">
          <h2 className="text-3xl translatable">{SchoolGet && SchoolGet.title ? SchoolGet.title: ""}</h2>
        </div>
        <div className="p-3 rounded-lg bg-light">
          <p className="translatable">{SchoolGet && SchoolGet.description ? SchoolGet.description: ""}</p>
        </div>
        <div className="bg-gray-400 rounded p-5">
          <h3 className="text-uppercase ps-3 mb-4 translatable">Votre avis compte</h3>
          <form onSubmit={(e) => {
            e.preventDefault();
            CreateComment(id, title, content, typecomment, SchoolGet.coverPicture);
          }}>
            <div className="flex flex-wrap">
              <div className="col-8">
                <textarea value={content}
                  onChange={(e) => { setcontent(e.target.value) }}
                  className="form-control bg-white border-0 translatable"
                  rows="3"
                  placeholder="commentaire.... "
                />
              </div>
              <div className="col-4">
                <button className="btn btn-primary w-full h-full bg-lime-600  py-3 flex justify-center items-center translatable" type="submit">envoyer</button>
              </div>
            </div>
          </form>
        </div>
        {
          commentList && commentList.length > 0 ?
            (
              <div className="mb-5">
                <h3 className="text-uppercase border-start border-5 ps-3 mb-4 translatable">{commentList.length} Avis</h3>
                {
                  commentList.map((item) => {
                    return (
                      <div className="d-flex mb-4">
                        <img src={`${item.person.coverPicture}`} className="img-fluid" style={{ width: "45px", height: "45px" }} />
                        <div className="ps-3">
                          <h6><a href=""></a> <small><i></i></small></h6>
                          <p className="bg-lime-700 text-white py-3 px-2 rounded-lg translatable">{item.content}</p>
                          {//<button className="btn btn-sm btn-light">Reply</button>
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            ) :
            <div className="bg-lime-600 text-white p-3 rounded-lg translatable">
              Soyez le premer à comenter
            </div>
        }
      </div>
    </div>
  )
}

export default VideoPage;








